import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Moment from 'moment'
//兼容ES6语法
import 'babel-polyfill'

//弹幕
import {vueBaberrage} from 'vue-baberrage'

Vue.use(vueBaberrage)

// 定义全局时间戳过滤器
Vue.filter('formatDate', function (value, formater = 'YYYY-MM-DD HH:mm:ss') {
    return Moment(value).format(formater)
})

Vue.prototype.$moment = Moment;//赋值使用
Vue.config.productionTip = false


Vue.config.productionTip = false;

// 全局样式
import "@styles/index.less";

// http配置
import axios from '@api/http';
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);

//Swiper组件的使用
import Swiper from 'vue-awesome-swiper';//引入组件
import 'swiper/dist/css/swiper.css';//引入样式
Vue.use(Swiper);//挂载实例

// antd组件的使用
import {
    Button,
    Carousel,
    Input,
    Icon,
    Select,
    Row,
    Col,
    pagination,
    Menu,
    Rate,
    input,
    avatar,
    Form,
    checkbox,
    message,
    notification,
    Tabs,
    divider,
    Modal,
    Upload,
    dropdown,
    breadcrumb,
    Tag,
    Statistic,
    Skeleton,
    Spin,
    Empty,
    Badge,
    skeleton,
    progress
} from 'ant-design-vue';
import {formatDurationMinute, isListEmpty, isTrue} from "@utils/func";

Vue.use(Button);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Row);
Vue.use(Col);
Vue.use(pagination);
Vue.use(Menu);
Vue.use(Rate);
Vue.use(input);
Vue.use(avatar);
Vue.use(Form);
Vue.use(checkbox);
Vue.use(Tabs);
Vue.use(divider);
Vue.use(Modal);
Vue.use(Upload);
Vue.use(dropdown);
Vue.use(breadcrumb);
Vue.use(Tag);
Vue.use(Statistic);
Vue.use(Skeleton);
Vue.use(Spin);
Vue.use(Empty);
Vue.use(Badge);
Vue.use(skeleton);
Vue.use(progress)

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$modal = Modal;
// 使用vant组件
import {Collapse, Icon as VantIcon, CellGroup, Cell, CollapseItem, Popup, DropdownMenu, DropdownItem} from 'vant';

Vue.use(VantIcon);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

import PageBackground from "@components/loading/PageBackground";

Vue.component(PageBackground.name, PageBackground)

//aliplayer
import VueAliplayer from 'vue-aliplayer'

Vue.use(VueAliplayer)

Vue.prototype.$func = {
    isTrue,
    isListEmpty
};

Vue.filter('formatDurationMinute', formatDurationMinute)

// 增加了百度统计
var _hmt = _hmt || [];
window._hmt = _hmt;

(function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?1e328b60ee13d9d9fdf487ab9f25a8d9";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
